<!-- Hero Section -->
<section class="hero">
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <h1 class="hero-title">VELOUR</h1>
    <p class="hero-subtitle">Where natural beauty meets expert care</p>
    <button type="button" class="hero-cta" (click)="booking.open()">Reserve Your Appointment</button>
  </div>
</section>

<!-- Philosophy Section -->
<section class="philosophy">
  <div class="philosophy-inner">
    <p class="philosophy-label">OUR PHILOSOPHY</p>
    <h2 class="philosophy-heading">A salon experience shaped by intention.</h2>
    <p class="philosophy-text">
      Specializing in natural blonding, lived-in color, extensions, and hair health — our approach is rooted in
      sustainability, premium products, and long-term care. Every service at Velour is designed to honor your
      natural beauty while delivering exceptional, lasting results.
    </p>
    <a class="philosophy-link" routerLink="/artist">Meet Our Artists <i class="fa-solid fa-arrow-right"></i></a>
  </div>
</section>

<!-- Full-Width Image Break -->
<section class="image-break">
  <img src="https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1400&q=80" alt="Salon environment with natural light">
</section>

<!-- Services Section -->
<section class="services-preview">
  <div class="services-inner">
    <p class="services-label">THE EXPERIENCE</p>
    <h2 class="services-heading">Premium Services, Natural Results</h2>
    <div class="services-grid">
      <div class="service-item">
        <div class="service-image">
          <img src="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&q=80" alt="Natural hair coloring">
        </div>
        <h3>Hair</h3>
        <p>Expert cuts, natural color, balayage, and blonding services using only the finest professional products.</p>
      </div>
      <div class="service-item">
        <div class="service-image">
          <img src="https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?w=600&q=80" alt="Luxury lash services">
        </div>
        <h3>Lashes</h3>
        <p>Classic, hybrid, and volume lash extensions crafted for a naturally enhanced, effortless look.</p>
      </div>
      <div class="service-item">
        <div class="service-image">
          <img src="https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?w=600&q=80" alt="Special event styling">
        </div>
        <h3>Events</h3>
        <p>Bridal, prom, and special occasion styling that celebrates your natural beauty on your most important days.</p>
      </div>
    </div>
    <a class="services-link" routerLink="/service">View All Services <i class="fa-solid fa-arrow-right"></i></a>
  </div>
</section>

<!-- Gallery / Inspiration Section -->
<section class="gallery">
  <p class="gallery-label">GET INSPIRED</p>
  <div class="gallery-grid">
    <img src="https://images.unsplash.com/photo-1605497788044-5a32c7078486?w=400&q=80" alt="Natural blonde highlights">
    <img src="https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=400&q=80" alt="Healthy hair texture">
    <img src="https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?w=400&q=80" alt="Balayage styling">
    <img src="https://images.unsplash.com/photo-1580618672591-eb180b1a973f?w=400&q=80" alt="Salon styling result">
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
  <h2>Ready for the Velour Experience?</h2>
  <p>Book your appointment today and discover the difference premium natural care makes.</p>
  <button type="button" class="cta-button" (click)="booking.open()">Book Now</button>
</section>
